import { useState } from "react";

export default function WhatsAppButton() {
  const [hovered, setHovered] = useState(false);
  const whatsappUrl = "https://wa.me/905001234567?text=Merhaba%2C%20kampanyalar%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum.";

  return (
    <div className="fixed bottom-6 right-6 z-50 flex items-center gap-3">
      {/* Tooltip */}
      <div
        className={`bg-white rounded-xl px-4 py-2.5 shadow-lg border border-[#F0EBE3] transition-all duration-300 ${
          hovered ? "opacity-100 translate-x-0" : "opacity-0 translate-x-4 pointer-events-none"
        }`}
      >
        <p className="text-[#3D2817] text-xs font-medium whitespace-nowrap">Hızlı bilgi ve randevu için</p>
        <p className="text-[#8B7D6B] text-[10px]">Hemen yanıt veriyoruz</p>
      </div>

      {/* Button */}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="nofollow noopener noreferrer"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        className="w-14 h-14 flex items-center justify-center rounded-full bg-[#25D366] hover:bg-[#1ebe5d] transition-all duration-200 cursor-pointer shadow-xl shadow-[#25D366]/40 hover:scale-110"
        style={{ animation: "waPulse 2.5s ease-in-out infinite" }}
        aria-label="WhatsApp ile iletişime geç"
      >
        <i className="ri-whatsapp-line text-white text-2xl" />
      </a>

      <style>{`
        @keyframes waPulse {
          0%, 100% { box-shadow: 0 0 0 0 rgba(37,211,102,0.4); }
          50% { box-shadow: 0 0 0 12px rgba(37,211,102,0); }
        }
      `}</style>
    </div>
  );
}
